import { ImageContainer } from "../../constants/ImagesConstants";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  capitalizeFirstLetter,
  createdAtFormat,
  decodeID,
  encodeID,
  formatSelectedDate,
  generateDateList,
  getLastURL,
  monthYear,
  compareSelectedDate,
  isFutureDate,
  sidebarOpen,
} from "../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import {
  DashboardBookingDetailAction,
  DashboardBookingChangeUpdateAction,
  DashboardBookingViewDetailAction,
} from "../../redux/Action/DashboardAction";
import moment from "moment";
import ListLoader from "../../components/ListLoader";
import Spinner from "../../components/Spinner";
import detaNOtFOund from "../../Assets/images/data-not-found.svg";
import Button from "../../components/Ui/Button";
import MarkCompleted from "../../components/Model/MarkCompleted";
import { FormattedMessage } from "react-intl";
import CancelReason from "../../components/Model/CancelReason";
import { BlockServiceReasonAction } from "../../redux/Action/Availability";
const { ProfileDetailIconImage } = ImageContainer;
import $ from "jquery";

const MyAppointments = () => {
  moment.locale("en");
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const viewId = getLastURL(location);
  const [status, setStatus] = useState(null);
  const pathname = location.pathname;
  const pathSegments = pathname.split("/");
  const currentMonth = decodeID(pathSegments[3]);
  const currentDate = decodeID(pathSegments[2]);

  const booking_detail = useSelector(
    (state: any) => state.DashboardBookingDetailState,
  );
  const dashboard_booking_accept_cancel_change = useSelector(
    (state: any) => state.DashboardBookingStatusChangeBookingState,
  );
  const booking_view_data = useSelector(
    (state: any) => state.DashboardBookingViewDetailState,
  );
  const mark_as_completed_data = useSelector(
    (state: any) => state.BookingMarkAsCompletedState,
  );

  // const params: any = { booking_date: decodeID(viewId) };
  const formattedDate = moment(currentDate).format("D");
  const [bookingStatus, setBookingStatus] = useState(true);

  const [date, setDate]: any = useState(formattedDate ? formattedDate : null);
  const containerRef: any = useRef(null);
  const dates = generateDateList();
  const scrollDivRef: any = useRef(null);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingData, setBookingData]: any = useState([]);
  const [selectedTab, setSelectedTab] = useState(null);
  const monthYearData = monthYear(currentMonth).split(" ");

  const [bookingViewData, setBookingViewData]: any = useState([]);
  const [loadingServices, setLoadingServices] = useState([{}]);
  const [selectedData, setSelectedData]: any = useState(null);

  const scrollLeft: any = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= 500;
    }
  };

  const scrollRight: any = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 500;
    }
  };

  const handleSelectDate = (selectDate: any) => {
    setDate(selectDate);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (page != 0) {
        setIsLoading(true);
      }
      dispatch(
        DashboardBookingDetailAction({
          page,
          status,
          pageSize: 20,
          booking_date: formatSelectedDate(
            monthYearData[1],
            monthYearData[0],
            date,
          ),
          booking_status: bookingStatus == true ? 1 : 2,
        }),
      );
    };
    fetchData();
  }, [
    page,
    status,
    dashboard_booking_accept_cancel_change,
    date,
    mark_as_completed_data?.status,
    dispatch,
    bookingStatus,
  ]);

  useEffect(() => {
    if (booking_detail?.status && booking_detail?.loading === false) {
      if (page === 0) {
        setBookingData(booking_detail?.data?.data?.rows);
      } else {
        setBookingData([...bookingData, ...booking_detail?.data?.data?.rows]);
      }
      setIsLoading(false);
    }
  }, [booking_detail]);

  const handleScroll = () => {
    if (page <= (booking_detail?.data?.data?.count * (page + 1)) / 10) {
      const div = scrollDivRef?.current;
      if (div && !isLoading) {
        const { scrollTop, scrollHeight, clientHeight } = div;
        if (
          Math.round(((scrollTop + clientHeight) * 100) / scrollHeight) ===
            100 &&
          !isLoading
        ) {
          setIsLoading(true);
          setPage(page + 1);
        }
      }
    }
  };

  const handleClick = (tabName: any) => {
    setStatus(tabName);
    setSelectedTab(tabName);
    // setBookingData([])
  };

  const add_block_service = useSelector(
    (state: any) => state.BlockServiceState,
  );

  const handleChangeStatus = (
    tabName: any,
    user_id: any,
    booking_id: any,
    service_id: any,
    booking_service_id: any,
  ) => {
    setPage(0);

    if (tabName == 2) {
      setSelectedData({
        tabName,
        user_id,
        booking_id,
        service_id,
        booking_service_id,
      });
      // dispatch(DashboardBookingChangeUpdateAction({
      //     "booking_id": booking_id, "booking_status": tabName, "reason": "REASON MANAGE BOOKING", user_id: user_id, service_id: service_id
      // }))
    }

    if (tabName == 1) {
      dispatch(
        DashboardBookingViewDetailAction({
          user_id: user_id,
          booking_id: booking_id,
          service_id: service_id,
          booking_service_id: booking_service_id,
        }),
      );
    }

    if (tabName == 3 || tabName == 0) {
      dispatch(
        DashboardBookingChangeUpdateAction({
          booking_id: booking_id,
          booking_status: tabName,
          reason: "REASON MANAGE BOOKING",
          user_id: user_id,
          service_id: service_id,
        }),
      );
    }
  };

  useEffect(() => {
    if (booking_view_data?.status) {
      setBookingViewData(booking_view_data?.data?.data);
    }
  }, [booking_view_data]);

  useEffect(() => {
    return () => {
      dispatch(DashboardBookingViewDetailAction("RESET"));
      dispatch(DashboardBookingChangeUpdateAction("RESET"));
      dispatch(DashboardBookingDetailAction("RESET"));
      setBookingData([]);
    };
  }, []);

  useEffect(() => {
    if (date !== null && containerRef.current) {
      const dateElementWidth = 40;
      const datesVisible = date > 15 ? -10 : 10;
      const totalDatesWidth = dateElementWidth * datesVisible;

      const selectedDateIndex = date - 1; // assuming date starts from 1
      const scrollPosition =
        selectedDateIndex * dateElementWidth -
        totalDatesWidth / 2 +
        dateElementWidth / 2;

      containerRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
      setBookingData([]);
      setPage(0);
    }
  }, [date, status]);

  const [cancelStatus, setCancelStatus] = useState(false);

  const handleCancelStatus = (e: any) => {
    setCancelStatus(true);
  };

  const handleToggle = () => {
    setBookingStatus((prevState) => !prevState);
  };

  const navigate = useNavigate();

  const handleBookingPage = (userId: any, bookingId: any, serviceId: any) => {
    //     <Link to={`/my-bookings-details/${encodeID(item?.user_id)}/${encodeID(item?.booking_id)}/${encodeID(item?.service_id)}`} className="stretched-link flex-fill"></Link>
    navigate(
      `/my-bookings-details/${encodeID(userId)}/${encodeID(bookingId)}/${encodeID(serviceId)}`,
    );
  };

  return (
    <>
      <div className="col-lg-9">
        {dashboard_booking_accept_cancel_change?.loading ||
        booking_view_data?.loading ||
        mark_as_completed_data?.loading ||
        add_block_service?.loading ? (
          <Spinner />
        ) : (
          ""
        )}
        {/* {dashboard_booking_accept_cancel_change?.loading || booking_view_data?.loading || mark_as_completed_data?.loading || add_block_service?.loading ? <Spinner /> : ""} */}
        {/* {dashboard_booking_accept_cancel_change?.loading || booking_detail?.loading ? <Spinner /> : ""} */}
        <div className="dashboard bg-white">
          <div className="dashboardTop d-sm-flex align-items-center">
            <h2>
              <button
                type="button"
                className="btn mobileMenu p-1 d-lg-none"
                onClick={() => {
                  sidebarOpen();
                }}
              >
                <span className="icon-menu-right"></span>
              </button>{" "}
              <FormattedMessage id="My_Bookings" />
              {bookingStatus == true ? " Online" : " Offline"}
            </h2>

            <div className="form-check form-switch ms-auto">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={bookingStatus}
                onChange={handleToggle}
                style={
                  bookingStatus == false
                    ? { backgroundColor: "#df2929", borderColor: "#df2929" }
                    : {}
                }

                // style= {{ bookingStatus == true ? backgroundColor: "green", borderColor: "green" :"" }}
              />
              {/* <input
                                className="form-check-input"
                                type="checkbox"
                                style={{ backgroundColor: "green", borderColor: "green" }}
                            /> */}
            </div>

            <Breadcrumb items={[]} />
          </div>

          <div className="dashboarcard">
            <div className="CurrentMonth">
              <div className="C_month_Title">
                <h6>{monthYear(currentMonth)}</h6>
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn me-2"
                    onClick={scrollLeft}
                  >
                    <span className="icon-angel-left"></span>
                  </button>
                  <button type="button" className="btn" onClick={scrollRight}>
                    <span className="icon-angel-right"></span>
                  </button>

                  {/* <button type='button' className='btn me-2'><span className="icon-angel-left" onClick={scrollLeft}></span></button>
                                    <button type='button' className='btn'><span className="icon-angel-right" onClick={scrollRight}></span></button> */}
                </div>
              </div>

              <ul className="dateList mt-4" ref={containerRef}>
                {dates.map((item, index) => (
                  <li
                    key={index}
                    className={date == item.date ? "active" : ""}
                    onClick={() => handleSelectDate(item?.date)}
                  >
                    {item.day} <span>{item.date}</span>
                  </li>
                ))}
              </ul>
            </div>

            <hr />
            <ul
              className="nav nav-pills tabstyle1 mb-3"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${selectedTab === null ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected="true"
                  onClick={() => handleClick(null)}
                >
                  All
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${selectedTab == "0" ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected="true"
                  onClick={() => handleClick("0")}
                >
                  <FormattedMessage id="Upcoming" />
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${selectedTab == "1" ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected="true"
                  onClick={() => handleClick("1")}
                >
                  <FormattedMessage id="Completed" />
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${selectedTab == "2" ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected="true"
                  onClick={() => handleClick("2")}
                >
                  <FormattedMessage id="Cancelled" />
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${selectedTab == "3" ? "active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected="true"
                  onClick={() => handleClick("3")}
                >
                  <FormattedMessage id="No_Shown_upon" />
                </button>
              </li>
            </ul>

            <div
              className="tab-content scroll-data"
              id="pills-tabContent"
              ref={scrollDivRef}
              onScroll={handleScroll}
            >
              <div tabIndex={0}>
                <div className="row g-2 align-items-stretch">
                  {bookingData?.length > 0 ? (
                    bookingData?.map((item: any) => {
                      return (
                        <>
                          <div className="col-sm-6 col-lg-6 col-xl-4">
                            <div className="card bookingBOx">
                              <div className="card-header">
                                <div className="userInfo">
                                  <figure>
                                    <img
                                      src={
                                        item?.user_details?.profile_pic
                                          ? item?.user_details?.profile_pic
                                          : ProfileDetailIconImage
                                      }
                                      onError={(e: any) =>
                                        (e.target.src = ProfileDetailIconImage)
                                      }
                                    />
                                  </figure>
                                  <div className="userInfoName">
                                    <h6>
                                      {capitalizeFirstLetter(
                                        item?.user_details?.name
                                          ? item?.user_details?.name
                                          : "",
                                      )}
                                    </h6>
                                    <div>
                                      {item?.u_id ? "#" + item?.u_id : ""}
                                    </div>
                                    <div>
                                      {item?.booking_status == 1 ? (
                                        <FormattedMessage id="online" />
                                      ) : (
                                        <FormattedMessage id="offline" />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="userAction">
                                  <a
                                    href={`mailto:${item?.user_details?.email}`}
                                    className="btn btnroundIcon ms-1 ms-sm-2"
                                    title={
                                      item?.user_details?.email
                                        ? item?.user_details?.email
                                        : "email"
                                    }
                                  >
                                    <i className="icon-mail"></i>
                                  </a>
                                  {/* <button type='button' title={item?.user_details?.email ? item?.user_details?.email : 'email'} className='btn btnroundIcon'><i className="icon-mail"></i></button> */}
                                  {/* <button type='button' title={item?.user_details?.phone_number ? (item?.user_details?.phone_country_code && `+${item?.user_details?.phone_country_code.replace(/^\++/, '')}` + ' ' + item?.user_details?.phone_number) : ""} className='btn btnroundIcon ms-1 ms-sm-2'><i className="icon-call-1"></i></button> */}
                                  <button
                                    type="button"
                                    className="btn btnroundIcon ms-1 ms-sm-2"
                                    title={
                                      item?.user_details?.phone_number
                                        ? `+${item?.user_details?.phone_country_code} ${item?.user_details?.phone_number}`
                                        : ""
                                    }
                                    onClick={() => {
                                      if (item?.user_details?.phone_number) {
                                        const phone = `+${item?.user_details?.phone_country_code?.replace(/^\++/, "")}${item?.user_details?.phone_number}`;
                                        window.location.href = `tel:${phone}`;
                                      }
                                    }}
                                  >
                                    <i className="icon-call-1"></i>
                                  </button>
                                </div>
                              </div>

                              <div
                                className="card-body"
                                onClick={() => {
                                  handleBookingPage(
                                    item?.user_id,
                                    item?.booking_id,
                                    item?.service_id,
                                  );
                                }}
                              >
                                <div className="text-center border-bottom">
                                  {item?.parent_id_details?.length > 0 && (
                                    <small className="addition-service">
                                      {" "}
                                      Additional Services{" "}
                                      {"+" + item?.parent_id_details?.length}
                                    </small>
                                  )}
                                </div>
                                <div className="bookingID">
                                  <div>
                                    {item?.created_at
                                      ? createdAtFormat(item?.created_at)
                                      : null}
                                  </div>
                                  {item?.status == 0 || item?.status == 4 ? (
                                    <div className="orderstatus upcoming">
                                      <span>
                                        <i className="icon-upcoming"></i>
                                      </span>
                                      {<FormattedMessage id="Upcoming" />}
                                    </div>
                                  ) : item?.status == 1 ? (
                                    <div className="orderstatus Completed">
                                      <span>
                                        <i className="icon-upcoming"></i>
                                      </span>
                                      {<FormattedMessage id="Completed" />}
                                    </div>
                                  ) : item?.status == 2 ? (
                                    <div className="orderstatus Cancelled">
                                      <span>
                                        <i className="icon-upcoming"></i>
                                      </span>
                                      {<FormattedMessage id="Cancelled" />}
                                    </div>
                                  ) : item?.status == 3 ? (
                                    <div className="orderstatus Cancelled">
                                      <span>
                                        <i className="icon-upcoming"></i>
                                      </span>
                                      {<FormattedMessage id="No_Shown_upon" />}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="AppointmentInfo">
                                  <div>
                                    <p>
                                      <FormattedMessage id="Booking_for" />{" "}
                                      <span>
                                        {item?.booking_date
                                          ? moment(item?.booking_date).format(
                                              "D MMM YYYY",
                                            )
                                          : ""}
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      <FormattedMessage id="Booking_Id" />{" "}
                                      <span>
                                        {item?.booking_id
                                          ? "#" + item?.booking_id
                                          : ""}
                                      </span>
                                    </p>
                                  </div>
                                  <div>
                                    <p>
                                      <FormattedMessage id="Service_name" />{" "}
                                      <span className="text-truncates">
                                        {item?.service_details?.name
                                          ? item?.service_details?.name
                                          : ""}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* <div className='card-footer p-0 bg-white'>
                                                                <div className="appointmentBOTTomBTN d-flex flex-xl-column flex-xxl-row gap-2 p-3">
                                                                    {<Button text="Mark as completed" type="button" className="btn btn-sm-outline flex-fill" /> }
                                                                    {<Button text="Mark as completed" type="button" className="btn btn-sm-outline flex-fill" /> }
                                                                </div>
                                                            </div> */}
                              <div className="card-footer p-0 bg-white">
                                <div className="appointmentBOTTomBTN d-flex flex-column gap-2 p-3">
                                  {item?.status == 3 ? (
                                    <>
                                      <Button
                                        text={
                                          (
                                            <FormattedMessage id="restore_upcoming" />
                                          ) as any
                                        }
                                        type="button"
                                        className="btn btn-sm-outline flex-fill"
                                        onClick={() =>
                                          handleChangeStatus(
                                            "0",
                                            item?.user_details?.id,
                                            item?.booking_id,
                                            item?.service_id,
                                            item?.id,
                                          )
                                        }
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-sm-outline flex-fill"
                                        onClick={(e: any) => {
                                          handleChangeStatus(
                                            "2",
                                            item?.user_details?.id,
                                            item?.booking_id,
                                            item?.service_id,
                                            item?.id,
                                          );
                                          handleCancelStatus(e);
                                        }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#cancelReason"
                                      >
                                        {
                                          (
                                            <FormattedMessage id="cancel_booking" />
                                          ) as any
                                        }
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-sm-outline flex-fill"
                                        data-bs-toggle="modal"
                                        data-bs-target="#MarkToCompleted"
                                        onClick={() =>
                                          handleChangeStatus(
                                            "1",
                                            item?.user_id,
                                            item?.booking_id,
                                            item?.service_id,
                                            item?.id,
                                          )
                                        }
                                      >
                                        <FormattedMessage id="mark_completed" />
                                      </button>
                                    </>
                                  ) : (item?.status == 0 ||
                                      item?.status == 4) &&
                                    isFutureDate(item?.slot_st) ? (
                                    <>
                                      <button
                                        type="button"
                                        className="btn btn-sm-outline flex-fill"
                                        onClick={(e: any) => {
                                          handleChangeStatus(
                                            "2",
                                            item?.user_details?.id,
                                            item?.booking_id,
                                            item?.service_id,
                                            item?.id,
                                          );
                                          handleCancelStatus(e);
                                        }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#cancelReason"
                                      >
                                        {" "}
                                        {
                                          (
                                            <FormattedMessage id="cancel_booking" />
                                          ) as any
                                        }
                                      </button>
                                    </>
                                  ) : (
                                    item?.status == 0 && (
                                      <>
                                        <Button
                                          text={
                                            (
                                              <FormattedMessage id="no_Shown-up" />
                                            ) as any
                                          }
                                          type="button"
                                          className="btn btn-sm-outline flex-fill"
                                          onClick={() =>
                                            handleChangeStatus(
                                              "3",
                                              item?.user_details?.id,
                                              item?.booking_id,
                                              item?.service_id,
                                              item?.id,
                                            )
                                          }
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-sm-outline flex-fill"
                                          data-bs-toggle="modal"
                                          data-bs-target="#MarkToCompleted"
                                          onClick={() =>
                                            handleChangeStatus(
                                              "1",
                                              item?.user_id,
                                              item?.booking_id,
                                              item?.service_id,
                                              item?.id,
                                            )
                                          }
                                        >
                                          <FormattedMessage id="mark_completed" />
                                        </button>
                                      </>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })
                  ) : (
                    <div>
                      {booking_detail?.loading ? (
                        <>
                          <div className="row">
                            <div className="col-md-6 col-lg-4 col-xxl-4">
                              <div className="card bookingBOx">
                                <div className="card-header placeholder-glow">
                                  <span className="placeholder col-8"></span>
                                  <span className="placeholder col-4 ms-2"></span>
                                </div>
                                <div className="card-body">
                                  <div className="bookingID card-title placeholder-glow">
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-5 ms-2"></span>
                                  </div>
                                  <div className="card-text">
                                    <div className="AppointmentInfo placeholder-glow">
                                      <div className="placeholder col-4"></div>
                                      <div className="placeholder col-4 ms-2"></div>
                                      <div className="placeholder col-4 ms-2"></div>
                                    </div>
                                  </div>
                                  <div className="d-flex p-3">
                                    <a
                                      href="#"
                                      tabIndex={-1}
                                      className="btn btn-sm-fill flex-fill disabled placeholder col-6"
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-lg-6 col-xxl-4">
                              <div className="card bookingBOx">
                                <div className="card-header placeholder-glow">
                                  <span className="placeholder col-8"></span>
                                  <span className="placeholder col-4 ms-2"></span>
                                </div>
                                <div className="card-body">
                                  <div className="bookingID card-title placeholder-glow">
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-5 ms-2"></span>
                                  </div>
                                  <div className="card-text">
                                    <div className="AppointmentInfo placeholder-glow">
                                      <div className="placeholder col-4"></div>
                                      <div className="placeholder col-4 ms-2"></div>
                                      <div className="placeholder col-4 ms-2"></div>
                                    </div>
                                  </div>
                                  <div className="d-flex p-3">
                                    <a
                                      href="#"
                                      tabIndex={-1}
                                      className="btn btn-sm-fill flex-fill disabled placeholder col-6"
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <img
                            className="detaNotFOund"
                            src={detaNOtFOund}
                            alt=""
                          />
                          <h5 className="text-center mt-4">
                            <FormattedMessage id="there_are_currently_no_bookings_here" />{" "}
                            .
                          </h5>
                          {/* <h5 className='text-center mt-4'> There are currently no  {bookingStatus == true ? "online" : "offline"} bookings.</h5> */}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* {booking_detail?.loading ? <ListLoader /> : ""} */}
            </div>
          </div>
        </div>
      </div>
      <MarkCompleted serviceId={bookingViewData} />
      <CancelReason
        status={cancelStatus}
        setCancelStatus={setCancelStatus}
        payload={selectedData}
      />
    </>
  );
};

export default MyAppointments;
